import Icon from '../components/Icon.vue'

Icon.register({
  copyright: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM373.1 354.8c1.6-1.9 2.9-5.3 2.9-7.8 0-2.2-1-5.3-2.3-7.1l-24.5-33.6c-4.4-6.1-13.4-6.6-18.5-1.1-0.3 0.3-26.8 28.6-65.5 28.6-48.8 0-74.3-40.1-74.3-79.7 0-42.5 27.8-76.1 73.9-76.1 35.4 0 61.6 23.7 61.9 23.9 5.5 5.1 14.2 4 18.2-2.3l22.4-34.7c1.1-1.6 1.9-4.6 1.9-6.5 0-2.6-1.4-6.2-3.2-8.1-1.5-1.6-36.5-38.9-103.4-38.9-81.8 0-143.8 62.1-143.8 143.4 0 82.3 59.8 145.6 144.5 145.6 70.1 0 108.3-43.9 109.9-45.7z'
      }
    ]
  }
})
